import { ReduceStore } from 'flux/utils';
import { Record, Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';


export class User extends Record({
  id: null,
  email: '',
  auth0: false,
  dbUser: '',
  tableauUser: '',
  memberships: [],
}) {

  get ready() { return true; }
}

class SimpleUser extends Record({
  id: null,
  email: '',
  auth0: null,
}) {}


function setAll(state, newData) {
  // Right now, this is a noop based on current data, and returns a new map.
  // At some point, the behavior may take into account the current state of the store.
  return state.clear().withMutations(map => {
    return newData.reduce((users, item) => (users.set(item.id, new SimpleUser(item))), map);
  });
}

function set(state, id, newData) {
  return state.set(id, new SimpleUser({
    id: newData.id,
    email: newData.email,
    auth0: newData.auth0,
  }));
}


class UserStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.USER_LIST_LOADED:
        return setAll(state, action.users);
      case Constants.Admin.USER_DATA_LOADED:
        return set(state, action.userId, action.payload);
      case Constants.Admin.MEMBERSHIP_CREATED:
        return set(state, action.membership.user.id, action.membership.user);
      case Constants.Admin.CURRENT_USER_LOADED:
        return set(state, action.user.id, action.user);
      case Constants.Admin.MEMBERSHIP_DELETED:
        // TODO: Remove membership in here, or maybe membershipStore
        return state;
      default:
        return state;
    }
  }

  getUserList() {
    return this.getState().valueSeq().sortBy(user => user.email);
  }

  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }
}


const instance = new UserStore(AppDispatcher);
export default instance;
